import angular from 'angular';
import serviceModule from './service/module';

export default angular
    .module('paysera.config', [
        serviceModule
    ])
    .name
;
